export const faqData = [
  {
    title: "후원 신청은 어떻게 하나요?",
    content:`온라인으로 정기, 일시후원 신청하실 수 있고 무통장입금으로 후원하실 수 있습니다. 온라인으로 정기, 일시후원 약정 시 자동이체, 카드결제 중 선택하여 납부하실 수 있습니다. 무통장 입금 후원 후 기부금 영수증 발급, 후원 안내를 위해 사무처로 연락 바랍니다. 
    * 후원 문의 02-6318-9000`
  },
  {
    title: "기부금은 어떻게 사용되나요? ", 
    content: `환경·안전·보건 분야의 인재를 양성하고 지속가능한 사회를 만드는 대안개발을 위해 사용됩니다. <br />
    · 인재양성사업 – 석·박사과정, 글로벌리더십 장학지원 / 박사후펠로우,특정주제연구자 연구지원<br />
    · 대안개발사업 – 시민 아이디어 지원 풀씨, 풀꽃, 풀숲, 국제 풀씨 사업<br />
    · 교육·문화·협력사업 – 미세먼지교육, 환경아카이브풀숲, 일환경건강센터 등`
  },
  {
    title: '기부금은 공정하고 투명하게 사용되나요?',
    content: `숲과나눔은 지정기부금단체로 기부금 단체 법적 요건을 준수하고 있으며
    투명하고 정직한 후원금 사용을 위해 외부 회계감사를 진행하고 있습니다.`
  },
  {
    title: '후원내역은 어떻게 확인 할 수 있나요?',
    content: `‘나의 후원’페이지에서 로그인 후 기부 내역을 확인하실 수 있습니다.`
  },
  {
    title: '개인정보, 결제정보를 변경하려면 어떻게 해야 하나요? ',
    content: `개인정보 변경의 경우 ‘나의 후원’ 페이지에서 로그인 후 변경 가능합니다.
    결제정보에 대한 변경 사항이 있으실 경우 재단으로 연락 주시면 해당 내용 변경하여 드립니다. <br />* 후원 문의 02-6318-9000`
  },
  {
    title: '기부금 영수증은 어떻게 받을 수 있나요?',
    content: `주민등록번호 13자리가 등록된 기부자는 매년 1월 국세청의 연말정산간소화서비스에서 출력하실 수 있으며 ‘나의 후원’ 페이지에서도 내역 확임과 출력이 가능합니다. `
  },
  {
    title: '기부금 영수증을 다른 사람의 이름으로 발급 가능한가요?',
    content: `기부금 영수증은 다른 사람의 이름으로 변경하여 발급이 불가하며 본인 명의로 발급됩니다.<br />본인 명의로 발급된 기부금 영수증은 연간 소득 금액 100만원 이하인 기본공제대상(배우자, 직계존속, 직계비속, 형제자매 등)이 발급받은 것을 합산하여 공제가 가능합니다.`
  },
];